import { useEffect, useState } from 'react';

/**
 * 값 디바운스. 검색 입력이 매 타이핑마다 쿼리를 트리거하지 않게 한다.
 * @param value 원본 값
 * @param delayMs 지연(ms)
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
